import $ from "cash-dom";
import zoom from "./function_zoom";

export default (function () {
    var selector = "[data-layout='annotation']";

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_annotation.js initialized", "green");

        var $hotspot = $(selector).find("[data-annotation]");
        var $lightbox = $(`<div id="lightbox" class="fixed inset global flex center-content clip bg-none z-4"></div>`);
        var $descriptionBox = $(
            `<div class="description-box copy-xs flex column justify-between sans c-accent absolute bottom-0.5 sm:bottom-1.0 left-0.5 sm:left-1.0 md:left-auto right-0.5 sm:right-1.0 px-0.5 py-0.5 bg-lighten z-1 fade-in transition-sm radius-0.125 md:width-4col" aria-hidden>
                <h3 class="headline copy-lg bold uppercase c-accent mb-0.25 hyphens-manual lh-1"></h3>
                <div class="description scroll-y hyphens-auto scroll-shadows"></div>
                <div class="toolbar flex justify-between align-center mt-0.5">
                    <div class="navigation flex row gx-0.25 no-shrink">
                        <button class="pointer lh-0 aspect-1:1 width-1.5 sm:width-1.0 radius-round c-accent bg-white hover:bg-page" data-prev>
                            <svg class="icon stroke-lg mirror-x" style="aspect-ratio: 1"><use href="#chevron-right"></use></svg>
                            <span class="sr-text">${jdmn_l10n.previous}</span>
                        </button>
                        <button class="pointer lh-0 aspect-1:1 width-1.5 sm:width-1.0 radius-round c-accent bg-white hover:bg-page" data-next>
                            <svg class="icon stroke-lg" style="aspect-ratio: 1"><use href="#chevron-right"></use></svg>
                            <span class="sr-text">${jdmn_l10n.previous}</span>
                        </button>
                    </div>
                    <div class="flex row gx-0.25 no-shrink">
                        <button class="pointer lh-0 aspect-1:1 width-1.5 sm:width-1.0 radius-round c-accent bg-white hover:bg-page" data-minimize>
                            <svg class="icon stroke-lg fade-in" style="aspect-ratio: 1"><use href="#enlarge"></use></svg>
                            <svg class="icon stroke-lg" style="aspect-ratio: 1"><use href="#shrink"></use></svg>
                            <span class="sr-text">${jdmn_l10n.minimize}</span>
                        </button>
                        <button class="pointer lh-0 aspect-1:1 width-1.5 sm:width-1.0 radius-round c-accent bg-white hover:bg-page enlarge-click" data-close>
                            <svg class="icon stroke-lg" style="aspect-ratio: 1"><use href="#close"></use></svg>
                            <span class="sr-text">${jdmn_l10n.close}</span>
                        </button>
                    </div>
                </div>
            </div>`,
        );
        var $closeButton = $descriptionBox.find("[data-close]");
        var $navButton = $descriptionBox.find(".navigation button");
        var $hotspotToggleButton = $(selector).find("[data-hotspot-toggle]");
        var $minimizeButton = $descriptionBox.find("[data-minimize]");
        var $context = $descriptionBox.find(".description, .headline, .navigation, [data-close]");
        var $instance = null;

        var index = null;
        var max = null;

        function closeHandler(_e) {
            index = null;
            max = null;

            $navButton.off("click").attr("disabled", null);
            $closeButton.off("click");
            $minimizeButton.off("click");
            $descriptionBox.removeClass("on");
            $lightbox.toggleClass("bg-none bg-page");
            $lightbox.find("img").remove();
            $lightbox.remove();
            $("html").removeClass("scroll-locked");
            $hotspot.removeClass("fade-in");
        }

        function handleDisabledStates() {
            if (index == 0) $navButton.filter("[data-prev]").attr("disabled", "");
            else $navButton.filter("[data-prev]").attr("disabled", null);

            if (index == max) $navButton.filter("[data-next]").attr("disabled", "");
            else $navButton.filter("[data-next]").attr("disabled", null);
        }

        function getInitialOffset(_initialRect) {
            var fromLeft = _initialRect.left;
            var fromTop = _initialRect.top;
            var toLeft = (window.innerWidth - _initialRect.width) / 2;
            var toTop = (window.innerHeight - _initialRect.height) / 2;

            return { x: fromLeft - toLeft + "px", y: fromTop - toTop + "px" };
        }

        $hotspotToggleButton.on("click", function () {
            $instance = $(this).parents(selector);
            $instance.find(".hotspots").toggleClass("fade-in pointer-none");
            $(this).find(".icon").toggleClass("on");
        });

        $hotspot.on("click", function (_e) {
            $instance = $(this).parents(selector);

            index = $instance.find("[data-annotation]").index(this);
            max = $instance.find("[data-annotation]").length - 1;

            var $image = $instance.find("img");
            var $clone = $image.clone();

            var headlineContent = $instance.find(".headline").eq(index).html();
            var descriptionContent = $instance.find(".description").eq(index).html();
            var theme = $instance.parents("[data-theme]").data("theme");
            var focus = $(this).data("focus");
            var scale = $(this).data("scale");
            var initialRect = $image[0].getBoundingClientRect();
            var initialScale = $image.width() / window.innerWidth;
            var initialOffset = getInitialOffset(initialRect);

            // handleDisabledStates();
            $descriptionBox.find(".headline").html(headlineContent);
            $descriptionBox.find(".description").html(descriptionContent);
            $clone.css("transform", `translate(${initialOffset.x}, ${initialOffset.y}) scale(${initialScale})`);
            $("html").addClass("scroll-locked");
            $hotspot.addClass("fade-in");
            $clone.addClass("transition-lg");
            $lightbox.attr("data-theme", theme);
            $lightbox.append($descriptionBox);
            $lightbox.append($clone);
            $("body").append($lightbox);

            $clone.on("load", function () {
                zoom($clone, focus, scale);
                $lightbox.toggleClass("bg-none bg-page");
                $descriptionBox.addClass("on");
            });

            $closeButton.on("click", closeHandler);

            $minimizeButton.on("click", function () {
                $descriptionBox.toggleClass("left-0.5 sm:left-1.0 md:left-auto md:width-4col md:width-auto");
                $descriptionBox.find(".toolbar").toggleClass("mt-0.5");
                $(this).find("svg").toggleClass("fade-in");
                $context.toggleClass("none");
            });

            $navButton.on("click", function () {
                switch (index) {
                    case 0:
                        index = $(this).is("[data-next]") ? index + 1 : max;
                        break;
                    case max:
                        index = $(this).is("[data-next]") ? 0 : index - 1;
                        break;
                    default:
                        index = $(this).is("[data-next]") ? index + 1 : index - 1;
                }

                var $hotspot = $instance.find("[data-annotation]").eq(index);
                var focus = $hotspot.data("focus");
                var scale = $hotspot.data("scale");
                var headlineContent = $instance.find(".headline").eq(index).html();
                var descriptionContent = $instance.find(".description").eq(index).html();

                // handleDisabledStates();

                $descriptionBox.find(".headline").html(headlineContent);
                $descriptionBox.find(".description").html(descriptionContent);
                $descriptionBox.find(".description")[0].scrollTop = 0;
                zoom($clone, focus, scale);
            });
        });

        $(window).on("escKey", closeHandler);
    }

    $(document).ready(init);
})();
